exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n#dailySchedules .v-tabs .v-tabs-bar__content {\n  border-bottom: 1px solid #e0e0e0;\n}\n#dailySchedules .actions {\n  background-color: white;\n  border-bottom: 1px solid #e0e0e0;\n}\n#dailySchedules .footer {\n  border-top: thin solid rgba(0, 0, 0, 0.12);\n}\n#dailySchedules .daily-schedule-dial {\n  right: 0px !important;\n}\n#dailySchedules tr.obsolete td span {\n  color: #9e9e9e !important;\n}\n#dailySchedules thead th span {\n  font-size: 12px !important;\n}", ""]);

// exports
exports.locals = {
	"bodyFontFamily": "\"Roboto\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Helvetica Neue\", \"Microsoft YaHei\", 微软雅黑, STXihei, 华文细黑, \"WenQuanYi Micro Hei\", 文泉驿微米黑, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",
	"error": "#E74C3C"
};